import type { TokenUsage } from './common.interface';
import type {
    AIDisclosureParagraphEditType,
    AIDisclosureParagraphType,
} from '@/services/ai-disclosure/type/ai-disclosure.enum';
import type { SSEStreamService } from '@patsnap-utils/sse';

export interface ApiGetDisclosureContentRequest<ContentType> {
    task_id: string;
    current_step: string;
    content_type: ContentType;
    text?: string;
}

export type ApiGetDisclosureContentResponse = {
    content: string;
    token_usage: TokenUsage;
    status: string;
};

export const GetDisclosureContent = Symbol('GetDisclosureContent');

export interface GetDisclosureContent {
    getDisclosureContent(data: ApiGetDisclosureContentRequest<AIDisclosureParagraphEditType | AIDisclosureParagraphType>): SSEStreamService<ApiGetDisclosureContentResponse>;
}
